<template>
  <div id="lv2">
    <div class="row no-gutters" id="searchContainer">
      <div class="col-12">
        <MiniSearchWidget
          v-if="$isMobile()"
          @search="fetchListings"
        ></MiniSearchWidget>

        <SearchWidget
          v-else
          id="searchWidget"
          @search="fetchListings"
          :showMap="false"
          :compact="true"
        ></SearchWidget>
      </div>
    </div>
    <div class="row no-gutters" id="sectionContainer">
      <div class="col-lg-7 col-sm-12" id="left">
        <div
          class="row no-gutters"
          id="promotedListings"
          v-if="
            !this.loading &&
            this.listings !== undefined &&
            this.listings.length !== 0
          "
        >
          <div class="col">
            <PromotedListings></PromotedListings>
          </div>
        </div>

        <div class="row no-row-padding" id="resultsContainer">
          <div class="col-12">
            <div class="row" id="innerResults">
              <div
                v-if="
                  this.loading ||
                  (this.listings !== undefined && this.listings.length === 0)
                "
                id="placeholders"
                class="col-12 d-flex align-items-center justify-content-center"
              >
                <div class="d-flex flex-column">
                  <template v-if="this.loading">
                    <Spinner
                      :message="$t('views.lv2.loading.message')"
                    ></Spinner>
                  </template>
                  <template v-else-if="this.listings.length === 0">
                    <div class="text-center">
                      <h2>{{ $t("views.lv2.noResults.title") }}</h2>
                      <p>{{ $t("views.lv2.noResults.description") }}</p>
                    </div>
                  </template>
                </div>
              </div>

              <template v-else>
                <div
                  class="col-sm-12 col-md-6 col-lg-6 col-xl-4"
                  v-for="(res, idx) in listings"
                  :key="idx"
                >
                  <ListingCard :listing="res"></ListingCard>
                </div>
                <div
                  class="col-12 d-flex align-items-center justify-content-center"
                >
                  <PaginationController
                    :pagination.sync="pagination"
                  ></PaginationController>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-5 no-row-padding d-none d-lg-block"
        id="right"
        v-if="showMap"
      >
        <MapContainer
          :listings="this.listings"
          :loading="this.loading"
        ></MapContainer>
      </div>
    </div>
  </div>
</template>

<script>
import ListingCard from "@/components/level2/ListingCard";

import Toggle from "@/components/common/Toggle";
import Spinner from "@/components/common/Spinner";
import PaginationController from "@/components/common/PaginationController";
import SearchWidget from "@/components/level2/searchWidget/SearchWidget";
import MiniSearchWidget from "@/components/level2/searchWidget/MiniSearchWidget";
import { mapState } from "vuex";
import PromotedListings from "@/components/level2/PromotedListings";
import MapContainer from "@/components/level2/MapContainer";
import ModalOverlay from "@/components/common/ModalOverlay";

export default {
  name: "LevelTwoView",
  // mixins: [mobileDetect],
  components: {
    ListingCard,
    Toggle,
    Spinner,
    SearchWidget,
    MapContainer,
    PromotedListings,
    PaginationController,
    ModalOverlay,
    MiniSearchWidget,
  },
  metaInfo() {
    return {
      title: this.metaInfoTitle,
    };
  },
  beforeRouteEnter(to, from, next) {
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called!
    next((vm) => {
      vm.verifyRoute(vm, to, from, next);
    });
  },
  beforeRouteUpdate(to, from, next) {
    return this.verifyRoute(this, to, from, next);
  },
  watch: {
    // query: function() {
    //     if (!this.fetchingRegions && !this.loading) {
    //         console.error("Fetching from watcher")
    //         this.fetchListings();
    //     } else {
    //         console.log("Skipping fetch, loading");
    //     }
    // },
    isMobile: function () {
      this.showMap = !isMobile;
    },
    deviceType: function () {
      console.log("Changed device type. It's now " + deviceType);
    },
    "pagination.currentPage": {
      deep: true,
      handler: function (newVal, oldVal) {
        console.log(`Pagination changed fron ${oldVal} to ${newVal}`);
        if (newVal !== oldVal && oldVal !== 0) {
          this.fetchListings();
        }
      },
    },
  },
  methods: {
    verifyRoute: function (vm, to, from, next) {
      let toPath = to.path;
      // In this case, we have a region, or at least what we suspect to be one

      // Emulate a search
      vm.loading = true;

      // Usual beauty with callbacks....
      const _vm = vm;

      console.log("toPath: " + toPath);

      // This will check and perform the fetch, if necessary
      // THe second param makes it so we may use cached results
      vm.$store
        .dispatch("getRegions", true)
        .then((res) => {
          let toPath = to.path;

          if (toPath === "/search") {
            console.log("The path is the basic search. Checking for params");

            if (to.query !== undefined && Object.keys(to.query).length > 0) {
              console.log("Possible params found, applying changes");

              // Set the base query
              this.$store.commit("setBaseQuery");

              if (to.query.houseType !== undefined) {
                let houseType = to.query.houseType;
                let locale = this.$i18n.locale;

                console.log("Found house type to apply: " + houseType);

                let houseTypes = _vm.$store.getters.getHouseTypes;
                // Deactivate all, then activate only the one we want
                houseTypes.map((el) => {
                  if (el.localizedName[locale] === houseType) {
                    el.value = true;
                  } else {
                    el.value = false;
                  }
                });

                // Push into storage
                _vm.$store.commit("setHouseTypes", houseTypes);
              }

              // Check for any match for the props
              let props = _vm.$store.getters.getProperties;
              let propKeys = props.map((el) => el.key);
              let requiredProps = Object.keys(to.query).filter((value) =>
                propKeys.includes(value)
              );

              if (requiredProps.length > 0) {
                // Activate all props
                props
                  .filter((property) => requiredProps.includes(property.key))
                  .map((el) => (el.value = to.query[el.key]));
                _vm.$store.commit("setProperties", props);
              }

              // Verify if ch is set. This is a workaround for issue #130
              // Will force objects to be located in CH only
              let nonItaly =
                Object.keys(to.query).filter((value) => value === "ch").length >
                0;
              if (nonItaly) {
                let regions = _vm.$store.getters.getRegions;
                // Find italy's IDX
                let italyIdx = regions.findIndex(
                  (el) => el.localizedName.it === "Italia"
                );
                console.log("ITaly Idx");
                console.log(italyIdx);
                // If the index is found
                if (italyIdx > -1) {
                  // Deactivate only italy
                  _vm.$set(regions[italyIdx], "value", false);
                  // Commit the query
                  _vm.$store.commit("setRegions", regions);
                }
              }
            }
            vm.fetchListings();
            return next();
          }

          // We now need to check if the path we found matches any of our paths
          let regions = _vm.$store.getters.getRegions;
          console.log("regions: " + JSON.stringify(regions));
          let regionUrls = regions.map((el) => {
            return el.url;
          });
          console.log("regionUrls: " + regionUrls);

          if (regionUrls.indexOf(toPath) === -1) {
            // Match not found, get out!
            return _vm.$router.push("/not-found");
          }

          // Set all regions to false, EXCEPT for the one that actually matches
          for (let i = 0; i < regions.length; i++) {
            _vm.$set(regions[i], "value", regions[i].url === toPath);
          }
          console.log("regions: " + JSON.stringify(regions));

          // Commit the query
          _vm.$store.commit("setRegions", regions);

          // Perform the actual search!
          _vm.fetchListings();

          return next();
        })
        .catch((err) => {
          console.log(err);
          // Push to an error page
          return _vm.$router.push("/not-found");
        });
    },
    preparePropertiesQuery: function () {
      const propertiesCopy = JSON.parse(
        JSON.stringify(this.$store.getters.getProperties)
      );
      let queryComponents = propertiesCopy
        .filter((el) => {
          // We just want to pass on the ones that are activated
          return el.value;
        })
        .map((el) => {
          if (["internet", "swimmingPool", "grill"].includes(el.key)) {
            el.key = el.key + ".value";
          }
          return `${el.key}:${el.value ? "true" : "false"}`;
        });
      console.log(queryComponents);

      if (
        !(
          this.isUndefined(this.query.selectedDates) ||
          this.isUndefined(this.query.selectedDates.start) ||
          this.isUndefined(this.query.selectedDates.end)
        )
      ) {
        // We need to check if the date is less than three days
        let startDate = this.query.selectedDates.start;
        let endDate = this.query.selectedDates.end;
        const diffTime = Math.abs(endDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays < 4) {
          queryComponents.push("shortStayAllowed:true");
        }
      }

      let totalPeople = this.query.numberOfAdults;

      if (this.query.numberOfKids > 0) {
        // We need all houses that have kidsAllowed = true
        queryComponents.push("childrenAllowed:true");
        totalPeople += this.query.numberOfKids;
      }

      if (totalPeople > 0) {
        queryComponents.push("numberOfPeople > " + (totalPeople - 1));
      }

      let query = queryComponents.join(" AND ");

      // if (propertiesQuery !== "") {
      //     query += " AND " + propertiesQuery;
      // }

      return query;
    },
    prepareRegionsQuery: function () {
      // Pre-flight checks
      // If no region is selected, select them all!
      let regions = this.$store.getters.getRegions;
      let regionCount = regions.length;
      let disabledRegions = regions.filter((el) => el.value === false).length;

      if (regionCount !== 0 && regionCount === disabledRegions) {
        regions.map((el) => (el.value = true));
        // Save the query
        this.$store.commit("setRegions", regions);
      }

      // It is easier to negate the value here. So we exclude those that have been deactivated

      // Get all regions
      let regionsQuery = this.$store.getters.getRegions
        .filter((el) => !el.value)
        .map(
          (el) =>
            "localizedName." +
            this.$i18n.locale +
            "!'" +
            el.localizedName[this.$i18n.locale] +
            "'"
        )
        .join(" AND ");

      return regionsQuery;
    },
    prepareHouseTypesQuery: function () {
      // It is easier to negate the value here. So we exclude those that have been deactivated
      // We need to get the current locale to get the current name
      let locale = this.$i18n.locale;

      // House types
      let houseTypesQuery = this.$store.getters.getHouseTypes
        .filter((el) => !el.value)
        .map(
          (el) =>
            `localizedName.${locale}!'` +
            encodeURIComponent(el.localizedName[locale]) +
            "'"
        )
        .join(" AND ");

      return houseTypesQuery;
    },
    prepareSpecialOfferQuery: function () {
      let specialOfferRequired = this.$store.getters.getQuery.specialOffer;
      console.log(specialOfferRequired);
      if (specialOfferRequired !== undefined && specialOfferRequired) {
        return "specialOffer=true";
      }
      return "";
    },
    fetchListings: function () {
      // Different queries
      let propertiesQuery = this.preparePropertiesQuery();
      let regionsQuery = this.prepareRegionsQuery();
      let houseTypesQuery = this.prepareHouseTypesQuery();
      let specialOfferQuery = this.prepareSpecialOfferQuery();

      console.log("Properties: " + propertiesQuery);
      console.log("Regions: " + regionsQuery);
      console.log("HouseTypes: " + houseTypesQuery);
      console.log("specialOffer: " + specialOfferQuery);

      let pagination =
        this.pagination.currentPage === 0
          ? ``
          : `page=${this.pagination.currentPage - 1}&`;
      let url = `/listings/query?size=24&${pagination}`;

      let queryComponents = [];

      if (propertiesQuery !== "") {
        queryComponents.push(`properties=${propertiesQuery}`);
      }

      if (regionsQuery !== "") {
        queryComponents.push(`regions=${regionsQuery}`);
      }

      if (houseTypesQuery !== "") {
        queryComponents.push(`houseTypes=${houseTypesQuery}`);
      }

      if (specialOfferQuery !== "") {
        queryComponents.push(specialOfferQuery);
      }

      if (queryComponents.length !== 0) {
        url += queryComponents.join("&");
      }

      let body = this.isUndefined(this.query.selectedDates)
        ? {}
        : {
            startDate: this.normalizeDate(this.query.selectedDates.start),
            endDate: this.normalizeDate(this.query.selectedDates.end),
          };

      this.listings = undefined;
      this.loading = true;

      console.log(`Final URL for query: ${url}`);

      this.$http
        .post(url, body)
        .then((res) => {
          this.listings = res.data.content;
          this.pagination.totalPages = res.data.totalPages;
          this.pagination.currentPage = res.data.currentPage + 1;
          this.pagination.pageSize = res.data.pageSize;
          this.pagination.currentPageSize = res.data.content.length;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loading = false));
    },
  },
  computed: {
    metaInfoTitle: function () {
      // If regions are undefined, we get out
      let regions = this.$store.getters.getRegions;
      if (regions === undefined) {
        return `casafile - Ferienwohnungen und Immobilien im Tessin - Ferienhaus, Wohnung, Rustico, Villa`;
      }

      // Check the url first of all
      let urlComps = this.$route.path.split("/");

      // Get the last component (i.e. the region)
      let url = urlComps[urlComps.length - 1];

      // Find a match based on the url
      let match = regions.find((el) => el.url === "/" + url);

      // Assign the extra text
      let addendum = match ? "in " + match.localizedName.de + " " : "";

      return `casafile - Ferienwohnungen und Immobilien ${addendum}im Tessin - Ferienhaus, Wohnung, Rustico, Villa`;
    },
    areListingsUndefined: function () {
      return this.isUndefined(this.listings);
    },
    fetchingRegions: function () {
      return this.$store.getters.fetchingRegions;
    },
    ...mapState(["query"]),
  },
  beforeMount() {
    // Set there the default query
    let currentQuery = this.$store.getters.getQuery;
    console.log(currentQuery);
    if (this.isUndefined(currentQuery)) {
      let defaultQuery = this.$store.getters.getDefaultQuery;
      this.$store.commit("setQuery", defaultQuery);
      console.log("Reset current query");
    }
  },
  data() {
    return {
      listings: [],
      pagination: {
        currentPage: 0,
        totalPages: 0,
      },
      loading: false,
      showMap: true,
    };
  },
};
</script>

<style lang="scss" scoped>
#left {
  overflow-y: auto;
  overflow-x: hidden;
}

#sectionContainer {
  padding: 0;
  height: 100%;
}

#innerResults {
  height: 100%;
}

// #resultsContainer {
//     // flex-grow:1;
// }

#searchContainer {
  padding-top: 10px;
  flex-shrink: 0;
}

#placeholders {
  height: 100%;
}

#promotedListings {
  padding: 10px;
  padding-top: 0;
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  #lv2 {
    height: calc(100vh - #{$navbar-height});
    display: flex;
    flex-direction: column;
  }

  #sectionContainer {
    flex-grow: 1;
    /* NEEDED OTHERWISE SCROLLING BREAKS */
    overflow: auto;
  }

  #resultsContainer {
    margin-top: -15px;
    height: 100%;
  }

  #searchContainer {
    padding-bottom: 10px;
  }

  #left {
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
  }
}
</style>

<style>
.gm-style-iw {
  padding: 0 !important;
  border-radius: 0 !important;
}

.gm-style-iw-d {
  max-width: none !important;
  max-height: none !important;
}

.gm-style-iw-d > div {
  max-width: none !important;
  max-height: none !important;

  margin-right: -18px;

  overflow: hidden;
}

.gm-ui-hover-effect {
  display: none !important;
}
</style>
